// Where the login sends somebody once they are in: the page that asked for it (`?next=`, which the
// server writes when a page needs an account — the link of an email to /analysis, say), or the front
// door. Only a path of this site: anything else in `next` would make the login page a redirect to
// wherever a stranger's link says.

export const FRONT_DOOR = "/";

export function safeNext(raw: string | null | undefined): string {
    const next = (raw ?? "").trim();
    if (!next.startsWith("/") || next.startsWith("//") || next.startsWith("/\\")) return FRONT_DOOR;
    if (/^\/(login|register)\b/.test(next)) return FRONT_DOOR;
    return next;
}
